// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"fc36803f","535":"dd83ae92"}[chunkId] + ".chunk.css";
};